var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.31 9.85v17.23A4.93 4.93 0 0 1 23.39 32H8.62a4.93 4.93 0 0 1-4.92-4.92V4.93A4.93 4.93 0 0 1 8.62.01h9.85c1.31 0 2.56 1.22 4.67 3.37.3.3.6.61.9.91s.61.61.91.9c2.15 2.11 3.37 3.36 3.37 4.67zm-2.46 1.23c0-1.23-1.24-1.23-2.46-1.23H19.7c-.68 0-1.23-.55-1.23-1.23V4.87c0-1.09.01-2.18-.87-2.41H8.63c-1.36 0-2.46 1.1-2.46 2.46v22.15c0 1.36 1.1 2.46 2.46 2.46H23.4c1.36 0 2.46-1.1 2.46-2.46z"
  })));
};
export default SvgDocument;